import React from "react";
import {  useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";

const SubNav = ({ Links }) => {

 const hasData =Links.details.data && Links.details.data.length > 0;  


  const navigate = useNavigate();
  
  // 🌟 Framer Motion setup for staggered grid loading
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.05 } 
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 20 },
    show: { opacity: 1, scale: 1, y: 0, transition: { type: "spring", stiffness: 300, damping: 24 } }
  };


  
  return (
    <div className="w-full flex  flex-col text-text-primary p-4 md:p-8 transition-colors duration-300">
      
      {/* Header Section */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mb-6 md:mb-10 text-center"
      >
        <h1 className="text-2xl lg:text-3xl xl:text-4xl font-black bg-clip-text text-transparent bg-gradient-to-r from-brand-primary to-purple-600 inline-block pb-2">
           {Links.details.title}
        </h1>
        {/*<p className="text-text-secondary mt-1 text-xs md:text-base font-bold">
          اختر النظام المطلوب للبدء
        </p>*/}
      </motion.div>

      {/* Grid Container */}
      <div dir="rtl" className="max-w-[1400px] mx-auto w-full">
        {hasData && (
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            animate="show"
            // Changed to 3 columns on mobile, scaling up on larger screens
            className="grid grid-cols-[repeat(auto-fill,minmax(100px,1fr))] gap-3 md:gap-5
            sm:grid-cols-[repeat(auto-fill,minmax(120px,1fr))] 
            md:grid-cols-[repeat(auto-fill,minmax(160px,1fr))] 
            lg:grid-cols-[repeat(auto-fill,minmax(200px,1fr))] 
            xl:grid-cols-[repeat(auto-fill,minmax(250px,1fr))]  "
          >
            {Links.details.data.filter(v=>Number(v.hidden) < 1 )
            .map((item,i) =>(
              
              <motion.div key={i} variants={itemVariants} className="h-full w-full py-2">
                <button 
                  onClick={() => navigate(item.to)} 
                  // Added 'w-full' to fix the button layout break. Adjusted padding and heights.
                  className="group w-full flex flex-col items-center justify-between pb-2 text-center rounded-2xl md:rounded-3xl bg-bg-secondary 
                   shadow-sm hover:shadow-xl  
                  transition-all duration-300 ease-out h-[100px] aspect-square sm:h-[110px] md:h-[140px] "
                >

                
                  
                  {/* Icon Container with Hover Glow */}
                  <div className="relative ">
                    <div className="absolute inset-0 bg-brand-primary opacity-0 group-hover:opacity-20 rounded-full blur-xl transition-opacity duration-300" />
                    
                    {/* Main Icon Box - Scaled down for mobile 3-col fit */}
                    <div  className=" w-16 h-8   md:w-20 md:h-10 rounded-xl md:rounded-2xl 
                    bg-bg-primary flex   justify-center 
                    transition-colors duration-300 shadow-sm relative z-10">
                      <Icon 
                        icon={item.icon || "solar:folder-with-files-bold-duotone"} 
                        // Icon size scaled down
                        className="-mt-[20%]  text-3xl sm:text-3xl md:text-4xl text-brand-primary group-hover:opacity-[0.7] transition-colors duration-300" 
                      />
                    </div>
                  </div>
                  
                  {/* Title - Text size set to text-xs for mobile, larger for desktop */}
                  <h2 className="text-xs sm:text-sm md:text-base lg:text-lg font-bold text-text-primary group-hover:text-brand-primary transition-colors duration-300 line-clamp-2 px-1">
                    {item.label}
                  </h2>
                  
                </button>
              </motion.div>

            ))}
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default SubNav;